import React from 'react';
import { Dimmer, Loader } from 'semantic-ui-react';
import styles from './Spinner.module.scss';

export interface ISpinnerProps {
  className?: string;
  content?: string;
  grey?: boolean;
  loading: boolean;
}

const Spinner = ({ className, loading, content, grey }: ISpinnerProps) => (
  <Dimmer
    className={classnames(className, grey && styles.grey)}
    active={loading}
    inverted={true}
  >
    <Loader inverted={true} content={content} />
  </Dimmer>
);

export default Spinner;
